import styled from 'styled-components';
import { Card, token } from '@bynder/design-system';

export const DesignCardPlaceholder = styled(Card.IconPlaceholder)`
    & svg {
        fill: ${token.gray400a};
        width: ${token.spacing9};
    }
`;
